import { useNavigate, useLocation } from 'react-router-dom';

// Shared mutable progress of the intro sequence (0 → 1) and the
// Earth-to-map pull-back (0 → 1). Plain objects so the 3D loop
// can read them without re-rendering React.
export const scrollProgress = { value: 0 };
export const transitionProgress = { value: 0 };

export const lenisRef = { current: null };

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef.current) lenisRef.current.scrollTo(el, { duration: 1.5 });
  else el.scrollIntoView({ behavior: 'smooth' });
}

export function scrollToTop() {
  if (lenisRef.current) lenisRef.current.scrollTo(0, { duration: 1.2 });
  else window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function useSectionNav() {
  const navigate = useNavigate();
  const location = useLocation();
  return (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => scrollToId(id), 140);
    } else {
      scrollToId(id);
    }
  };
}
